export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "click_to_scan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["코드를 스캔하려면 클릭하세요."])}
    }
  })
}
